export const getTitle = (text?: string) => text ? `Mint Paper | ${text}`: 'Mint Paper' 